
import Routes from '@/Routes';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AppEvents from '@/AppEvents';
import { Destination } from '@/components/Passenger/models/Destination';

@Component({
  components: {
  },
})
export default class ContactSupportPage extends Vue {
  loading: boolean = false;
  errorMessage: string = null;
  model: any = {
      message: '',
      version: this.$store.state.app.version.toString(),
      locale: this.$store.state.app.locale,
      destinationId: this.routeDestinationId,
      url: "",
  }
  supportRequestSent: boolean = false;

  $tlang: any;

  get destinations(): Destination[] {
    return this.$store.state.destination.destinations;
  }

  get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
  }

  get selectedDestinationId(): number {
    return this.routeDestinationId;
  }

  get selectedDestination(): Destination {
    return this.destinations.find(d => d.id === this.routeDestinationId);
  }

  setLocale(locale){
    this.$store.dispatch("app/setLocale", locale);
  }

  onBackClick() {
    this.$router.back();
  }
 
  async onSendClick() {
    this.errorMessage = null;
    this.loading = true;
    this.model.url = document.location.href;
    try {
        await this.$store.dispatch(
          'user/sendSupportRequest', 
          { 
            data: this.model 
          }
        );
    } catch (e) {
        const message = (e as any).response && (e as any).response.data ? (e as any).response.data : e;
        this.errorMessage = this.$i18n.translate("contactSupport.error." + message.toString(), message.toString());
        console.error("contactSupport error", e);
        this.loading = false;
        return;
    }
    this.supportRequestSent = true;
    this.loading = false;
  }
};
